import classNames from "classnames";
import PropTypes from "prop-types";
import { IconButton as MaterialIconButton } from "@mui/material";
import { handleEvent } from "@gx1/gx-npm-lib";
import styles from "./iconButton.styles.module.scss";

const propTypes = {
  ariaLabel: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.any, // ReactNode | ReactNode[] | string
  className: PropTypes.string,
  clickable: PropTypes.bool,
  cursor: PropTypes.string,
  disabled: PropTypes.bool,
  fillColor: PropTypes.string,
  focusBackgroundColor: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hover: PropTypes.bool,
  hoverBackgroundColor: PropTypes.string,
  hoverFill: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  onMouseUp: PropTypes.func,
  rippleBackgroundColor: PropTypes.string,
  rootClassName: PropTypes.string,
  style: PropTypes.object,
  tabIndex: PropTypes.number,
  transparentBackground: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 */
const IconButton = ({
  ariaLabel = "",
  backgroundColor,
  borderRadius = "4px",
  children,
  className,
  clickable = true,
  cursor,
  disabled = false,
  fillColor,
  focusBackgroundColor,
  height = 48,
  hover = false,
  hoverBackgroundColor,
  hoverFill,
  onClick,
  onKeyPress,
  onMouseUp,
  rippleBackgroundColor,
  rootClassName = "",
  style,
  tabIndex = 0,
  transparentBackground,
  width = 48,
}) => {
  const isNotClickable = transparentBackground || !clickable;

  const sxStyles = {
    width,
    height,
    borderRadius: Number.isInteger(borderRadius) ? `${borderRadius}px` : borderRadius,
    padding: 0,
    cursor: cursor || (clickable ? "pointer" : "default"),
    ...backgroundColor && { backgroundColor },
    ...fillColor && {
      "& svg path": {
        fill: fillColor,
      },
    },
    ...!clickable && {
      "& svg path": {
        fill: "var(--gravx-color-neutral-on-light-grey-7)",
      },
    },
    ...clickable && !hoverBackgroundColor && !focusBackgroundColor && {
      "&:hover": {
        backgroundColor: `rgba(from ${"var(--gravx-color-primary-on-light-moonstone)"} r g b / 0.6)`,
      },
      "&:focus": {
        backgroundColor: `rgba(from ${"var(--gravx-color-primary-on-light-moonstone)"} r g b / 0.6)`,
      },
      "&:hover svg path, &:focus svg path": {
        fill: "var(--gravx-color-neutral-on-light-grey-8)",
      },
    },
    ...hoverBackgroundColor && {
      "&:hover": {
        backgroundColor: hoverBackgroundColor,
      },
    },
    ...focusBackgroundColor && {
      "&:focus": {
        backgroundColor: focusBackgroundColor,
      },
    },
    ...hoverFill && {
      "&:hover svg path, &:focus svg path": {
        fill: hoverFill,
      },
    },
    ...rippleBackgroundColor && {
      "& .MuiTouchRipple-child": {
        backgroundColor: rippleBackgroundColor,
      },
    },
    ...!rippleBackgroundColor && !isNotClickable && {
      "& .MuiTouchRipple-child": {
        backgroundColor: `rgba(from ${"var(--gravx-color-primary-on-light-opal)"} r g b / 0.4)`,
      },
    },
    ...isNotClickable && {
      "& .MuiTouchRipple-child": {
        backgroundColor: "var(--gravx-color-neutral-on-light-grey-2)",
      },
    },
    ...style,
  };

  return (
    <MaterialIconButton
      aria-label={ariaLabel || null}
      className={classNames(
        styles.icon,
        transparentBackground && styles.transparentBackground,
        hover && styles.hoverStateActive,
        className,
        rootClassName,
      )}
      onClick={(e) => handleEvent(onClick, e)}
      onKeyPress={(e) => handleEvent(onKeyPress, e)}
      onMouseUp={(e) => handleEvent(onMouseUp, e)}
      sx={sxStyles}
      tabIndex={tabIndex}
      {...(disabled ? { disabled: true } : {})}
      {...(!clickable ? { disableRipple: true } : {})}
    >
      {children}
    </MaterialIconButton>
  );
};

IconButton.propTypes = propTypes;
export { IconButton };
